<div class="uig-tab">
  @if (components$ | async; as components) {
    <span class="uig-scroll-wrapper">
      <span class="uig-tab-button-wrapper">
        @for (component of components; track component; let i = $index) {
          @if (component) {
            <button [class.active]="i === activeTabNum" (click)="select(i, $event)" class="uig-tab-button">
              {{
              component.title | cxTranslate: {param: tabTitleParams[i] | async}
              }}
            </button>
          }
        }
      </span>
    </span>
    @for (component of components; track component; let i = $index) {
      @if (component) {
        <div [class.active]="i === activeTabNum">
          <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
            <ng-container [cxComponentWrapper]="component"></ng-container>
          </ng-template>
        </div>
      }
    }
  }
</div>
